import { PermissionMapping } from '@@/lib/permissions';

//i.e reader/writer/business-user = token passed to page component to handle page permissions
//i.e Array of permissions = a permission the user might have which would grant the key's level of access

export type PbrPermission = 'reader' | 'writer' | 'business-user';

export const pbrPermissionMapping: PermissionMapping<PbrPermission>[] = [
  {
    permissionSetMapping: {
      reader: ['pbr-reader', 'pbr-admin', 'pbr-business-user', 'categories-reader', 'categories-admin'],
      writer: ['pbr-admin', 'categories-admin'],
      'business-user': ['pbr-business-user', 'pbr-admin', 'categories-admin']
    },
    urlSignature: '/categories',
    showInNavbar: true,
    label: 'Categories'
  },
  {
    permissionSetMapping: {
      reader: ['pbr-reader', 'pbr-admin', 'pbr-business-user', 'proficiencies-reader', 'proficiencies-admin'],
      writer: ['pbr-admin', 'proficiencies-admin'],
      'business-user': ['pbr-business-user', 'pbr-admin', 'proficiencies-admin']
    },
    urlSignature: '/proficiencies',
    showInNavbar: true,
    label: 'Proficiencies'
  },
  {
    permissionSetMapping: {
      reader: ['pbr-reader', 'pbr-admin', 'pbr-business-user', 'assignments-reader', 'assignments-admin'],
      writer: ['pbr-admin', 'assignments-admin'],
      'business-user': ['pbr-business-user', 'pbr-admin', 'assignments-admin']
    },
    urlSignature: '/assignments',
    showInNavbar: true,
    label: 'Agent Assignments'
  },
  {
    permissionSetMapping: {
      reader: ['pbr-reader', 'pbr-admin', 'pbr-business-user', 'routing-rules-reader', 'routing-rules-admin'],
      writer: ['pbr-admin', 'routing-rules-admin'],
      'business-user': ['pbr-business-user', 'pbr-admin', 'routing-rules-admin']
    },
    urlSignature: '/routing-rules',
    showInNavbar: true,
    label: 'Routing Rules'
  }
];

export default pbrPermissionMapping;
